import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const WhatsHappening = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "What's Happening";

  const title = "What's Happening";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title> What's Happening | Money Service Business Advocacy UK</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="What's Happening | Money Service Business Advocacy UK "
        />
        <meta property="og:description" content="" />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{
                    display: "inline-block",
                    marginRight: letter === " " ? "0.3rem" : "0",
                    whiteSpace: "pre",
                  }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">What's Happening</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="row gy-8">
              <div className="col-lg-6">
                {/* learning Box Start */}
                <div
                className="learning-box mb-2 learning-bg-2 w-100 d-flex flex-column justify-content-between aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration={1000}
                >
                  <div className="row gy-4 gy-sm-0 align-items-center">
                    <div className="col-md-6">
                       <NavLink
                          to="/eventcalander"
                        >
                      <div className="learning-video">
                        <div className="glightbox">
                          <div className="learning-video__image">
                            <img
                              src="assets/images/events/calendar.jpg"
                              alt="Calendar"
                            />
                          </div>
                        </div>
                      </div>
                      </NavLink>
                    </div>
                    <div className="col-md-6">
                      <div className="learning-caption-02">
                         <NavLink
                          to="/eventcalander"
                        >
                        <h3 className="learning-caption-02__title">
                          Calendar
                        </h3>
                        </NavLink>
                        <p className="mb-0">
                          Plan smart. Never miss a moment.
                        </p>
                        <NavLink
                          to="/eventcalander"
                          className="learning-caption-02__btn btn btn-primary btn-hover-secondary"
                        >
                          View Schedule
                        </NavLink>
                      </div>
                    </div>
                  </div>                      
                </div>
                {/* learning Box End */}
              </div>
              <div className="col-lg-6">
                {/* learning Box Start */}
                <div
                 className="learning-box mb-2 learning-bg-2 w-100 d-flex flex-column justify-content-between aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration={1000}
                >
                 <div className="row gy-4 gy-sm-0 align-items-center">
                    <div className="col-md-6">
                       <NavLink
                          to="/events"
                        >
                      <div className="learning-video">
                        <div className="glightbox">
                          <div className="learning-video__image">
                            <img
                              src="assets/images/events/events.jpg"
                              alt="Events"
                            />
                          </div>
                        </div>
                      </div>
                      </NavLink>
                    </div>
                    <div className="col-md-6">
                      <div className="learning-caption-02">
                        <NavLink
                          to="/events"
                        >
                        <h3 className="learning-caption-02__title">
                          Events
                        </h3>
                        </NavLink>
                        <p className="mb-0">
                          Meet. Exchange. Elevate.
                        </p>
                        <NavLink
                          to="/events"
                          className="learning-caption-02__btn btn btn-primary btn-hover-secondary"
                        >
                          View Events
                        </NavLink>
                      </div>
                    </div>
                  </div>                     
                </div>
                {/* learning Box End */}
              </div>
            </div>

          </div>
        </section>
      </main>
    </div>
  );
};

export default WhatsHappening;
